import gql from 'graphql-tag';

export const ContentVersionHistoryQuery = gql`
	query ContentVersionHistoryQuery(
		$contentId: ID!
		$filter: ContentVersionHistoryFilter!
		$after: String
	) {
		contentVersionHistory(id: $contentId, after: $after, first: 10, filter: $filter) {
			nodes {
				contentId
				number
				author {
					id
				}
				updatedTime
			}
			pageInfo {
				hasNextPage
				hasPreviousPage
				startCursor
				endCursor
			}
		}
	}
`;
